export class AttendanceAlertRequest {
  employeeId: number;
  affiliationId: number;

  constructor(props: AttendanceAlertRequest) {
    this.employeeId = props.employeeId;
    this.affiliationId = props.affiliationId;
  }
}
